






























import mixins from 'vue-typed-mixins';
import _ from 'lodash';
import { editName } from '@/main/store/listEditTypes';

import { UserRole } from '@/main/components/constants';

import { Tabs } from '../../components';
import EditLayout from '../../EditLayout.vue';
import WorkflowButtons from '../../components/WorkflowButtons.vue';
import { EditMixin } from '../../mixins/editMixin';
import { NAME } from './constants';
import HlavniKarta from './HlavniKarta.vue';
import { MENU_CODE, TAB_NAMES, TABS } from '../../constants';

export default mixins(EditMixin).extend({
	name: editName(NAME),
	components: {
		HlavniKarta,
		EditLayout,
		Tabs,
		WorkflowButtons,
	},
	computed: {
		isUserServiceAdvisorOrCre(): boolean {
			return this.pracovnik.PracovnikOzn === (UserRole.SERVICE_ADVISER) || this.pracovnik.PracovnikOzn === (UserRole.CRE);
		},
		tabItems() {
			const tabItems = [];

			if (this.hasTabAccess(MENU_CODE, TABS.Hlavni)) tabItems.push(TAB_NAMES.HLAVNI);
			if (this.hasTabAccess(MENU_CODE, TABS.AddvancePay)) tabItems.push(TAB_NAMES.ADVANCEPAY);
			if (this.hasTabAccess(MENU_CODE, TABS.ND)) tabItems.push(TAB_NAMES.ND);
			if (this.hasTabAccess(MENU_CODE, TABS.Vydejky)) tabItems.push(TAB_NAMES.VYDEJKY);
			if (this.hasTabAccess(MENU_CODE, TABS.History)) tabItems.push(TAB_NAMES.HISTORY);
			if (this.hasTabAccess(MENU_CODE, TABS.Poznamky)) tabItems.push(TAB_NAMES.POZNAMKY);
			if (this.hasTabAccess(MENU_CODE, TABS.Zarazeni)) tabItems.push(TAB_NAMES.ZARAZENI);
			if (this.hasTabAccess(MENU_CODE, TABS.ZakazkyRef)) tabItems.push(TAB_NAMES.ZAKAZKY_REF);
			if (this.hasTabAccess(MENU_CODE, TABS.Doklady)) tabItems.push(TAB_NAMES.DOKLAD);
			if (this.hasTabAccess(MENU_CODE, TABS.OSC)) tabItems.push(TAB_NAMES.ZAKAZKY_OSC);

			return _.pick(TABS, tabItems);
		},
	},
	watch: {
		CancellationReasonType() {
			this.edit.IsCancellationButton = true;
		},
	},
});
